const url = {
    home: "/",
    inbox: "/inbox",
    sent: "/sent",
    inboxItem: "/inbox/:messageID",
    calendly: "/calendly",
    telemedicine: "/telemedicine",
    admin: "/super-admin",
    prepDashboard: "/prep-dashboard",
};

export const NAV_LABELS = {
    LOGO_ALT: "logo",
    HOME: "Home",
    MESSAGES: "My Messages",
    APPOINTMENTS: "Appointments",
    FIND_APPOINTMENTS: "Find Appointments",
    CALENDAR: "Calendar",
    LAB: "Lab",
    LAB_REQUESTS: "Lab Requests",
    LAB_RESULTS: "Lab Results",
    MANAGE_LAB_ORDER: "Manage Lab Order",
    SHIPPING_MANIFEST: "Shipping Manifest",
    SEARCH: "Search",
    PATIENT_SEARCH: "Patient Search",
    ORDER_KIT_LOOKUP: "Order & Kit Lookup",
    ACCOUNT: "My Account",
    MANAGE_PROFILE: "Manage Profile, License & Calendar",
    LOGOUT: "Logout",
    SUPER_ADMIN: "Super Admin Panel",
  };

export default url;